import {
  Button,
  FormHelperText,
  Grid,
  InputLabel,
  Stack,
  Typography,
} from "@mui/material";
import { ErrorMessage, Formik } from "formik";
import React, { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import InputField from "../elements/InputField";
import { validationSchemaProfile } from "./validationSchema";

const FormField = ({
  onSubmit,
  form,
  isEditable,
  isEmailEditable,
  setFormValues,
}) => {
  const [phoneNoError, setPhoneNoError] = useState();

  const handleInputChange = (e, fieldName) => {
    const newValue = e.target.value;
    setFormValues((prevValues) => ({
      ...prevValues,
      [fieldName]: newValue,
    }));
  };

    const handlePhoneChange = (value, country, setFieldValue) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      phone_number: value,
    }));

    setFieldValue('phone_number', value);

    const normalizedNumber = value.replace(/[^0-9]/g, "");

    const formatParts = country.format.split(" ");
    const localPartFormat = formatParts.slice(1).join(""); 
    let expectedLength = localPartFormat.replace(/[^.]/g, "").length;
    if(expectedLength >= 12){expectedLength = 12}
    const numberWithoutCode = normalizedNumber.slice(country.dialCode.length);
    if (!numberWithoutCode) {
      setPhoneNoError("Please enter a phone number.");
    } else if (numberWithoutCode.length > expectedLength) {
      setPhoneNoError(`The number is too long. It should be ${expectedLength} digits.`);
    } else if (numberWithoutCode.length < expectedLength) {
      setPhoneNoError(`Please enter a valid phone number of ${expectedLength} digits.`);
    } else {
      setPhoneNoError("");
    }
  };

  return (
    <Formik
      initialValues={form}
      validationSchema={validationSchemaProfile}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
           await onSubmit({
            ...values,
            first_name: values.first_name?.trim(),
            last_name: values.last_name?.trim(),
            email: values.email?.trim(),
          });
          setStatus({ success: true });
        } catch (err) {
          console.error(err);
          setStatus({ success: false });
          setErrors({ submit: err.message });
        }
        setSubmitting(false);
      }}
    >
      {({
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        values,
        setFieldValue,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Stack spacing={1}>
                <InputField
                  label="First Name"
                  id="first_name"
                  type="text"
                  name="first_name"
                  fullWidth
                  disabled={!isEditable}
                  placeholder="Enter first name"
                  onChange={(e) => {
                    handleChange(e);
                    handleInputChange(e, "first_name");
                  }}
                  onBlur={handleBlur}
                  value={values.first_name || ""}
                  error={touched.first_name && Boolean(errors.first_name)}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={1}>
                <InputField
                  label="Last Name"
                  id="last_name"
                  type="text"
                  name="last_name"
                  fullWidth
                  disabled={!isEditable}
                  placeholder="Enter last name"
                  onChange={(e) => {
                    handleChange(e);
                    handleInputChange(e, "last_name");
                  }}
                  onBlur={handleBlur}
                  value={values.last_name || ""}
                  error={touched.last_name && Boolean(errors.last_name)}
                />
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Stack spacing={1}>
                <InputField
                  label="Email Address"
                  id="email"
                  type="email"
                  name="email"
                  fullWidth
                  disabled={!isEmailEditable}
                  placeholder="Enter email address"
                  onChange={(e) => {
                    handleChange(e);
                    handleInputChange(e, "email");
                  }}
                  onBlur={handleBlur}
                  value={values.email}
                  error={touched.email && Boolean(errors.email)}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack spacing={1}>
                <InputLabel>Phone No.</InputLabel>
                <PhoneInput
                  disableAreaCodes={true}
                  inputProps={{
                    maxLength: 25,
                  }}
                  specialLabel=""
                  country={"in"}
                  value={values.phone_number || ""}
                  excludeCountries={[
                    "is",
                    "lu",
                    "ba",
                    "al",
                    "fo",
                    "gl",
                    "mc",
                    "sm",
                  ]}
                  countryCodeEditable={false}
                  onChange={(value, country) => 
                    handlePhoneChange(value, country, setFieldValue)
                  }
                  defaultErrorMessage="Invalid phone number"
                />
                {phoneNoError && (
                  <Typography variant="caption" color="error">
                    {phoneNoError || "Invalid phone number"}
                  </Typography>
                )}
              </Stack>
            </Grid>
            {values?.role === "org-admin" && (
              <Grid item xs={6}>
                <Stack spacing={1}>
                  <InputField
                    label="Organization Name"
                    id="organization_name"
                    type="text"
                    name="organization_name"
                    fullWidth
                    placeholder="Enter organization name"
                    onChange={(e) => {
                      handleChange(e);
                      handleInputChange(e, "organization_name");
                    }}
                    onBlur={handleBlur}
                    value={values.organization_name}
                    error={touched.organization_name && Boolean(errors.organization_name)}
                  />
                </Stack>
              </Grid>
            )}
          </Grid>
          <ErrorMessage name="submit">
            {(message) => <FormHelperText error>{message}</FormHelperText>}
          </ErrorMessage>
          <Button
            variant="contained"
            type="submit"
            sx={{
              mt: 3,
              float: "center",
              width: "100%",
              padding: "10px 0",
            }}
            disabled={isSubmitting || phoneNoError}
          >
            Save
          </Button>
        </form>
      )}
    </Formik>
  );
};

export default FormField;
